AuthRoute = require 'mixins/authenticated-route'

App.CategoryCreateDishRoute = Em.Route.extend AuthRoute,
  controllerName: 'dishEdit'

  model: ->
    organization = @controllerFor('categories').get('organization')

    @store.createRecord 'draft_dish',
      # todo i18n
      name: 'Новое блюдо'
      organization: organization

  setupController: (controller, model)->
    @_super(arguments...)
    category = @controllerFor('category').get('model')
    model.set('draft_category', category)


  renderTemplate: (controller, model) ->
    @render 'categories.dish-edit', controller: controller

